import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import State from 'types/State';
import firebase from 'firebase/app';
import config from 'lib/config';
import Cookies from 'js-cookie';

export default function useGoogleOneTap(): void {
  const isSignedIn = useSelector((state: State) => state.session.isSignedIn);

  const promptSignIn = (): void => {
    const googleAccounts = (google as any).accounts;

    if (typeof googleAccounts !== 'undefined') {
      googleAccounts.id.initialize({
        client_id: config.googleOAuthClientId,
        callback: (response: { credential: string }) => {
          firebase
            .auth()
            .signInWithCredential(firebase.auth.GoogleAuthProvider.credential(response.credential));
        },
        auto_select: true,
        context: 'use',
      });
      googleAccounts.id.prompt();
    }
  };

  useEffect(() => {
    const hasBeenPrompted = Cookies.get('has_been_prompted');
    if (
      !hasBeenPrompted &&
      !isSignedIn &&
      typeof google !== 'undefined' &&
      typeof window !== 'undefined'
    ) {
      promptSignIn();
    }
  }, [isSignedIn]);
}
